<div class="create-project-dialog">
  <div class="dialog-header">
    <h2>Create Project</h2>
    <button mat-icon-button type="button" (click)="cancel()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-body" *ngIf="!loadingMasters; else loadingTpl">
    <form [formGroup]="form" (ngSubmit)="submit()">
      <section class="form-section">
        <h3>Core details</h3>
        <div class="form-grid">
          <mat-form-field appearance="outline">
            <mat-label>Application *</mat-label>
            <mat-select formControlName="application_code">
              <mat-option *ngFor="let app of apps" [value]="app.code">
                {{ app.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Project Code *</mat-label>
            <input matInput formControlName="project_code" />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Project Name *</mat-label>
            <input matInput formControlName="name" />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Client *</mat-label>
            <mat-select formControlName="client_username">
              <mat-option *ngFor="let client of clients" [value]="client.username">
                {{ client.name || client.username }} ({{ client.username }})
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Coordinator *</mat-label>
            <mat-select formControlName="coordinator_username">
              <mat-option *ngFor="let c of coordinators" [value]="c.username">
                {{ c.name || c.username }} ({{ c.username }})
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Auditor {{ isWaterApp ? '*' : '' }}</mat-label>
            <mat-select formControlName="auditor_username">
              <mat-option [value]="''">None</mat-option>
              <mat-option *ngFor="let a of auditors" [value]="a.username">
                {{ a.name || a.username }} ({{ a.username }})
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Status *</mat-label>
            <mat-select formControlName="status">
              <mat-option *ngFor="let s of statusOptions" [value]="s.value">
                {{ s.label }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Project Type</mat-label>
            <mat-select formControlName="type">
              <mat-option *ngFor="let t of projectTypes" [value]="t">{{ t }}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Development Type</mat-label>
            <input matInput formControlName="development_type" />
          </mat-form-field>
        </div>
      </section>

      <section class="form-section">
        <h3>Project location</h3>
        <div class="form-grid">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Address</mat-label>
            <input matInput formControlName="address" />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>State</mat-label>
            <mat-select formControlName="state" (selectionChange)="onStateChange()">
              <mat-option [value]="''">Select state</mat-option>
              <mat-option *ngFor="let state of states" [value]="state">{{ state }}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>City</mat-label>
            <mat-select formControlName="city" (selectionChange)="onCityChange()">
              <mat-option [value]="''">Select city</mat-option>
              <mat-option *ngFor="let item of filteredCities" [value]="item.city">
                {{ item.city }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Pincode</mat-label>
            <input matInput formControlName="pin_code" />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Built-up Area</mat-label>
            <input matInput type="number" formControlName="built_up_area" />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Site Area</mat-label>
            <input matInput type="number" formControlName="site_area" />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Ground Coverage</mat-label>
            <input matInput type="number" formControlName="ground_coverage" />
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Description</mat-label>
            <textarea matInput rows="2" formControlName="description"></textarea>
          </mat-form-field>
        </div>
      </section>

      <section class="form-section">
        <h3>Project information (PI)</h3>
        <div class="form-grid">
          <mat-form-field appearance="outline">
            <mat-label>PI Owner</mat-label>
            <input matInput formControlName="pi_owner" />
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>PI Address</mat-label>
            <input matInput formControlName="pi_address" />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>PI State</mat-label>
            <mat-select formControlName="pi_state" (selectionChange)="onPiStateChange()">
              <mat-option [value]="''">Select state</mat-option>
              <mat-option *ngFor="let state of states" [value]="state">{{ state }}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>PI City</mat-label>
            <mat-select formControlName="pi_city" (selectionChange)="onPiCityChange()">
              <mat-option [value]="''">Select city</mat-option>
              <mat-option *ngFor="let item of filteredPiCities" [value]="item.city">
                {{ item.city }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>PI Pincode</mat-label>
            <input matInput formControlName="pi_pin_code" />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>PI Email</mat-label>
            <input matInput type="email" formControlName="pi_email_id" />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>PI Mobile</mat-label>
            <input matInput formControlName="pi_mobile" />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>PI Landline</mat-label>
            <input matInput formControlName="pi_landline" />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>PI Fax</mat-label>
            <input matInput formControlName="pi_fax" />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>PI Built Area</mat-label>
            <input matInput type="number" formControlName="pi_built_area" />
          </mat-form-field>
        </div>
      </section>

      <section class="form-section">
        <h3>Status &amp; flags</h3>
        <div class="form-grid">
          <mat-form-field appearance="outline">
            <mat-label>Total Cost</mat-label>
            <input matInput type="number" formControlName="total_cost" />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Status Remark</mat-label>
            <input matInput formControlName="status_remark" />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>No. of Visits (SNoVisit)</mat-label>
            <input matInput formControlName="s_no_visit" />
          </mat-form-field>

          <div class="checkbox-row">
            <mat-checkbox formControlName="s_training">Training</mat-checkbox>
            <mat-checkbox formControlName="s_visit">Visit</mat-checkbox>
            <mat-checkbox formControlName="is_active">Active</mat-checkbox>
            <mat-checkbox formControlName="is_on_hold">On Hold</mat-checkbox>
          </div>
        </div>
      </section>

      <section class="form-section" *ngIf="isSchoolApp">
        <h3>School details</h3>
        <div class="form-grid">
          <mat-form-field appearance="outline">
            <mat-label>Year of Establishment</mat-label>
            <input matInput formControlName="year_of_establishment" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>School Timings Begin</mat-label>
            <input matInput formControlName="school_timings_begin" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>School Timings End</mat-label>
            <input matInput formControlName="school_timings_end" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>No. of Working Days</mat-label>
            <input matInput type="number" formControlName="no_of_working_days" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Teaching Staff</mat-label>
            <input matInput type="number" formControlName="total_no_of_teaching_staff" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Non-teaching Staff</mat-label>
            <input matInput type="number" formControlName="total_no_of_non_teaching_staff" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Number of Students</mat-label>
            <input matInput type="number" formControlName="total_number_of_students" />
          </mat-form-field>
        </div>
      </section>

      <div class="dialog-actions">
        <button mat-stroked-button type="button" (click)="cancel()" [disabled]="submitting">
          Cancel
        </button>
        <button mat-flat-button color="primary" type="submit" [disabled]="submitting">
          {{ submitting ? 'Creating...' : 'Create Project' }}
        </button>
      </div>
    </form>
  </div>

  <ng-template #loadingTpl>
    <div class="loading-wrap">
      <mat-spinner diameter="40"></mat-spinner>
      <p>Loading master data...</p>
    </div>
  </ng-template>
</div>
